<template>
  <div id="grid-documento-diario-progreso">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsDocumento"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
              <td class="text-xs-left">{{ props.item.region }}</td>
              <td class="text-xs-left">{{ props.item.fechaInicio }}</td>
              <td class="text-xs-left">{{ props.item.fechaFin }}</td>
              <td class="text-xs-left">{{ props.item.dias }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Ver envíos"
                  @click="editProgreso(props.item.id, props.item.idSubitem)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "grid-documento-diario-progreso",
  components: {},
  props: {
    itemsDocumento: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      loading: false,
      contratoId: "",
      usuario: "",
      proceso: "",
      tipoUsuario: "",
      itemsProgreso: [],
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Tipo de Prueba", sortable: false, value: "fechaEntrega" },
        { text: "Region", sortable: false, value: "fechaActualizacion" },
        {
          text: "Fecha Inicio Distribución",
          sortable: false,
          value: "fechaProgreso",
        },
        {
          text: "Fecha Recepción Distribución",
          sortable: false,
          value: "fechaProgreso",
        },
        { text: "Días Distribución", sortable: false, value: "fechaProgreso" },
        { text: "Accion", sortable: false, value: "" },
      ],
    };
  },
  created() {
    this.subProceso = this.$store.getters.subProTabSelectedStored;
    this.idContrato = this.$store.getters.contratoStored;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.tipoUsuario = this.$store.getters.userLogged.tipo;
  },
  watch: {
    itemsDocumento(val) {
      this.miPaginacion.totalItems = this.itemsDocumento.length;
    },
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    editProgreso(id, idSubitem) {
      this.$router.push({
        name: "FormProgresoDiario",
        params: { tipeView: "consulta", idSubitem: idSubitem, idAcuerdo: id },
      });
    },
    newProgreso() {
      this.$router.push({
        name: "ProgresoRegistra",
        params: { tipeView: "crear" },
      });
    },
  },
};
</script>
